// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2075":"27e3545d","3362":"6d8ae9b3","9251":"f5f0f78e"}[chunkId] + ".chunk.css";
};